/* @generated */

// src/assets/ui-icon/line/text-style.tsx
import * as React from "react";
var TextStyleLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.5 17 4.179-13h2.236l4.178 13h-1.575l-1.286-4h-4.87l-1.286 4H6.5Zm5.297-11.577L9.844 11.5h3.906l-1.953-6.077Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M6 20h12v-1.5H6V20Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }));
export {
  TextStyleLine
};
